import SweetAlert from "react-bootstrap-sweetalert";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useMemo } from "react";
import { fetchRole, roleDeleted } from "../../../Redux/roleReduce";
import { useDispatch } from "react-redux";
import { verification } from "../../../Redux/usersReduce";
import { toast, ToastContainer } from "react-toastify";
import MaterialReactTable from 'material-react-table';
import { useHistory } from "react-router";
import { useTranslation } from 'react-multi-lang'

// core components
function ListRole({client}) {
  const dispatch = useDispatch();
  const navigate = useHistory();
  const t = useTranslation();
  const [alert, setAlert] = React.useState(null);
  const [entities, setEntities] = React.useState([]);
  const columns = useMemo(
    () => [
      //column definitions...
      {
        header: t("name"),
        accessorKey: "nom",
      },
      {
        accessorKey: 'id',
        header: 'actions',
        Cell: ({ cell, row }) => (
          <div className="actions-right block_action">
            <Button
              onClick={() => {
                navigate.push(client+"/role/update/" + cell.row.original.id);
              }}
              variant="warning"
              size="sm"
              className="text-warning btn-link edit"
            >
              <i className="fa fa-edit" />
            </Button>
            {/* <Button
              id={"idLigne_" + cell.row.original.id}
              onClick={(e) => {
                confirmMessage(cell.row.original.id, e);
              }}
              variant="danger"
              size="sm"
              className="text-danger btn-link delete"
            >
              <i className="fa fa-trash" id={"idLigne_" + cell.row.original.id} />
            </Button> */}
          </div>
        ),
      },
      //end
    ],
    [],
  );
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(
        <strong>

          {msg}
        </strong>
      );
    else
      toast.error(
        <strong>

          {msg}
        </strong>
      );
  };
  const confirmMessage = (id, e) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={"Êtes-vous sûr de vouloir supprimer ce rôle ?"}
        onConfirm={() => deleteRole(id, e)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      >
        {/* Êtes-vous sûr de supprimer cette User? */}
      </SweetAlert>
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };
  function ajouter() {
    navigate.push(client+"ajouterRole");
  }
  function deleteRole(id, e) {
    dispatch(roleDeleted({ id })).then((val) => {
      notify(1, t("role_supprimer_succes"));
      getRole();
      hideAlert();
    });
  }

  const getRole = useCallback(
    async () => {
      var root = await dispatch(fetchRole());
      setEntities(root.payload);
    },
    [dispatch]
  );

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    verifToken()
    getRole();
  }, [getRole]); //now shut up eslint

  return (
    <>
      {alert}
      <Container fluid>
        <ToastContainer />
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-info mr-1 float-left"
              type="button"
              onClick={ajouter}
            >
              <span className="btn-label">
                <i className="fas fa-plus"></i>
              </span>
              {t("role.add")}
            </Button>
          </Col>

          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">{t("role.list")}</Card.Title>
              </Card.Header>
              <Card.Body className="padding-0">
                <MaterialReactTable
                  columns={columns}
                  data={entities}
                  enableColumnActions={true}
                  enableColumnFilters={true}
                  enablePagination={true}
                  enableSorting={true}
                  enableBottomToolbar={true}
                  enableTopToolbar={true}
                  muiTableBodyRowProps={{ hover: false }}
                  displayColumnDefOptions={{
                    'mrt-row-numbers': {
                      size: 10,
                    },
                    'mrt-row-expand': {
                      size: 10,
                    },
                  }}
                  enableColumnFilterModes
                  initialState={{
                    columnVisibility: { description: false },
                    density: 'compact',
                    showGlobalFilter: true,
                    sorting: [{ id: 'tableInstanceAPI', desc: false }],
                  }}
                  filterFns={{
                    myCustomFilterFn: (row, id, filterValue) => {
                      const value = row.getValue(id);
                      return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
                    },
                  }}
                  globalFilterFn="myCustomFilterFn"
                  muiSearchTextFieldProps={{
                    placeholder: t("search"),
                    sx: { minWidth: '18rem' },
                    variant: 'outlined',
                  }}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListRole;
